import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  none: {
    marginLeft: '0.5rem',
    color: 'lightgrey'
  }
}))

export default useStyles
